import type { SVGProps } from "react";

export type IconName =
  | "home"
  | "book"
  | "film"
  | "map"
  | "wallet"
  | "flag"
  | "shopping-bag"
  | "search"
  | "x"
  | "chevron-left"
  | "chevron-right"
  | "clock"
  | "alert-circle"
  | "inbox"
  | "plus"
  | "more-horizontal"
  | "calendar"
  | "users"
  | "notebook"
  | "tag"
  | "check"
  | "user";

const PATHS: Record<IconName, string> = {
  home: "M3 10.5 12 3l9 7.5M5 9.5V21h5v-6h4v6h5V9.5",
  book: "M4 4.5A2.5 2.5 0 0 1 6.5 2H20v18H6.5A2.5 2.5 0 0 0 4 22.5V4.5ZM4 19.5A2.5 2.5 0 0 1 6.5 17H20",
  film: "M3 4h18v16H3V4Zm4 0v16M17 4v16M3 9h4M3 15h4M17 9h4M17 15h4",
  map: "m9 4-6 2v14l6-2 6 2 6-2V4l-6 2-6-2Zm0 0v14m6-12v14",
  wallet: "M3 7.5A2.5 2.5 0 0 1 5.5 5H19a2 2 0 0 1 2 2v2h-4.5a2.5 2.5 0 0 0 0 5H21v3a2 2 0 0 1-2 2H5.5A2.5 2.5 0 0 1 3 16.5v-9Z",
  flag: "M5 3v18M5 4h11l-2.5 4L16 12H5",
  "shopping-bag": "M6 8h12l-1 12H7L6 8Zm3 0a3 3 0 0 1 6 0",
  search: "M11 19a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm9 2-5.2-5.2",
  x: "M6 6l12 12M18 6 6 18",
  "chevron-left": "m15 6-6 6 6 6",
  "chevron-right": "m9 6 6 6-6 6",
  clock: "M12 7v5l3.5 2M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z",
  "alert-circle": "M12 8v5M12 15.5h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z",
  inbox: "M3 12h4.5l1.5 3h6l1.5-3H21M4.5 5h15l2 7v8a1 1 0 0 1-1 1H3.5a1 1 0 0 1-1-1v-8l2-7Z",
  plus: "M12 5v14M5 12h14",
  "more-horizontal": "M5 12h.01M12 12h.01M19 12h.01",
  calendar: "M4 5.5A1.5 1.5 0 0 1 5.5 4H19a1 1 0 0 1 1 1v16H5.5A1.5 1.5 0 0 1 4 19.5v-14ZM4 9h16M8 2v4",
  users: "M9 12.8a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4Zm7-.8a2.6 2.6 0 1 0 0-5.2 2.6 2.6 0 0 0 0 5.2ZM2.5 20c.7-3 3-5 6.5-5s5.8 2 6.5 5M15 15.5c2.6.3 4.3 1.8 4.9 4.5",
  notebook: "M5 3h14v18l-6-4-6 4V3Z",
  tag: "M9 3h6l6 6-9 9-6-6V3Z",
  check: "M5 12l5 5 9-11",
  user: "M12 12.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9ZM4 21c1-4 4-6.5 8-6.5S19 17 20 21",
};

export function Icon({ name, ...rest }: { name: IconName } & SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      width="20"
      height="20"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...rest}
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
